import {
  accountBase64ToBytes,
  importSyncKeyMaterial,
} from '@/db/accountSyncCrypto';
import { getOrCreateAccountSyncKey } from './api';

const SYNC_KEY_STORAGE_KEY = 'bunko.account.syncKey';

export function storeRawSyncKey(rawBase64: string): void {
  localStorage.setItem(SYNC_KEY_STORAGE_KEY, rawBase64);
}

export function clearLocalAccountSyncKey(): void {
  localStorage.removeItem(SYNC_KEY_STORAGE_KEY);
}

export async function importRawSyncKey(rawBase64: string): Promise<CryptoKey> {
  return importSyncKeyMaterial(accountBase64ToBytes(rawBase64));
}

export async function getAccountSyncKey(token: string): Promise<CryptoKey> {
  const { rawKey } = await getOrCreateAccountSyncKey(token);
  storeRawSyncKey(rawKey);
  return importRawSyncKey(rawKey);
}
